import { Alert, Dialog, Skeleton, Stack } from '@all-manager/design-system-v2';
import { Controller } from "react-hook-form";
import DateField from "../../../../../components/modals/components/DateFieldOk";
import DescriptionFieldOk from "../../../../../components/modals/components/DescriptionFieldOk";
import type { SubjectHistoryFeed } from "../../../../../types";
import DocumentsFormSection from "../../../../documents/external-components/DocumentsFormSection/DocumentsFormSection";
import RevealFieldButton from "../RevealFieldButton/RevealFieldButton";
import useAddIncidentActionModal from "./useAddIncidentActionModal";

type Props = {
  onClose: () => void;
  subjectId: string;
  item?: SubjectHistoryFeed;
}

export default function AddIncidentActionModal(props: Props) {
  const {
    form,
    handleConfirm,
    isLoading,
    serverError,
    isDocumentLoading,
    showDocuments,
    revealDocuments,
  } = useAddIncidentActionModal(props);

  return (
    <Dialog
      open
      onClose={props.onClose}
      maxWidth="sm"
      fullWidth
      title={props.item ? "Modifier l'incident" : "Signaler un incident"}
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: props.item ? 'Enregistrer' : "Signaler l'incident",
          onClick: form.handleSubmit(handleConfirm),
          loading: isLoading,
          disabled: isDocumentLoading,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: props.onClose,
          disabled: isLoading,
        },
      }}
    >
      <Stack spacing={2}>
        {serverError ? <Alert severity="error">{serverError}</Alert> : null}

        <DateField
          name="date"
          form={form}
          label="Date de constatation"
          isTimeManaged={false}
          required
        />

        <DescriptionFieldOk
          form={form}
          name="comment"
          label="Description de l'incident"
        />

        {showDocuments ? (
          isDocumentLoading ? (
            <Skeleton variant="rounded" height={120} aria-label="Chargement des documents" />
          ) : (
            <Controller
              name='documents'
              control={form.control}
              render={({ field }) => (
                <DocumentsFormSection
                  documents={field.value}
                  onChange={field.onChange}
                  subjectId={props.subjectId}
                />
              )}
            />
          )
        ) : (
          <RevealFieldButton label="Ajouter des photos ou documents" onClick={revealDocuments} />
        )}
      </Stack>
    </Dialog>
  );
}
